import { PureComponent, Children } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { add as addEvent } from 'bianco.events';

const subscriptions = new Set();

addEvent(document, 'visibilitychange', function() {
    subscriptions.forEach(cmp => {
        cmp.props.onChange(document.visibilityState, document.hidden);
    });
});

export default class PageVisibility extends PureComponent {
    static defaultProps = {
        onChange: noop,
    };
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    };

    componentDidMount() {
        subscriptions.add(this);
    }

    componentWillUnmount() {
        subscriptions.delete(this);
    }

    render() {
        return Children.only(this.props.children);
    };
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/page-visibility/index.js